import { MIN_STAKE } from '@star-snake/shared'

export type StartActionKind = 'trial' | 'paid' | 'deposit'

export interface StartActionState {
  kind: StartActionKind
  balance: number
  freeGamesLeft: number
  showBalance: boolean
  badgeText: string
  helperText: string | null
}

export function formatFreeGamesLeft(freeGamesLeft: number): string {
  return `${freeGamesLeft} free game${freeGamesLeft === 1 ? '' : 's'} left`
}

export function getStartActionState(balance: number, freeGamesLeft: number): StartActionState {
  if (freeGamesLeft > 0) {
    return {
      kind: 'trial',
      balance,
      freeGamesLeft,
      showBalance: false,
      badgeText: 'FREE',
      helperText: formatFreeGamesLeft(freeGamesLeft),
    }
  }

  if (balance >= MIN_STAKE) {
    return {
      kind: 'paid',
      balance,
      freeGamesLeft,
      showBalance: true,
      badgeText: '1 STAR',
      helperText: null,
    }
  }

  return {
    kind: 'deposit',
    balance,
    freeGamesLeft,
    showBalance: true,
    badgeText: 'TOP UP',
    helperText: 'Buy Telegram Stars to start playing.',
  }
}
